<template>
  <erp-s-field
      :view="this.fieldView || 'tl'"
      :label="label || 'Fipe Ano Modelo'"
      :label-width="labelWidth"
      :helper="helper"
      :error="error"
      :helper-position="helperPosition || 'lb'"
  >
    <erp-select
        @input="__set"
        :loading="loading"
        :placeholder="placeholder || 'Selecione'"
        :options="asyncdata"
        v-model="model"
        :multiple="multiple"
        :simpleBorder="simpleBorder"
    ></erp-select>
  </erp-s-field>
</template>

<script>
import SelectMixin from '../../../../mixins/SelectMixin'
import {listAnosFipe as list} from '../../../../domain/bem/services'

export default {
  name: 'FipeAnoSelect',
  mixins: [SelectMixin],
  props: {},
  data () {
    return {
      asyncdata: []
    }
  },
  computed: {},
  mounted () {
  },
  components: {},
  methods: {
    load (id) {
      this.loading = true
      list(id)
        .then((response) => {
          this.loading = false
          if (!Array.isArray(response.data.result)) {
            return
          }
          let list = response.data.result.map((obj) => {
            return {
              ...obj,
              label: obj.nome,
              value: obj.id
            }
          })

          !this.multiple && !this.required && list.unshift({label: this.placeholder || 'Selecione', value: null})
          this.asyncdata = list
          this.$nextTick(() => {
            if (this.value) {
              let val = this.value
              let item = this.asyncdata.find((v) => v.id === val)
              if (item && item.label) {
                this.$emit('anoSelected', item.label)
              }
            }
          })
        })
        .catch((error) => {
          this.loading = false

        })
    },
    __set (e) {
      let val = e && e.target ? e.target.value : e
      this.__emit(val)
      let item = this.asyncdata.find((v) => v.id === val)
      if (item && item.label) {
        this.$emit('anoSelected', item.label)
      }
    },
    getSelectedObject (label) {
      return this.asyncdata.find((v) => String(v.nome) === String(label))
    }
  }
}
</script>
